import React from 'react';
import {Divider, Typography} from "@material-ui/core";
import styled from "styled-components";
import { DetailItemRow } from '../../../Shared/styles';

export const DetailTitle = styled(Typography)`
  font-weight: 600 !important;
`;

interface IDetailTitleRowProps {
    title: string;
}

const DetailTitleRow = ({title}: IDetailTitleRowProps) => (
    <>
        <DetailItemRow>
            <DetailTitle>
                {title}
            </DetailTitle>
        </DetailItemRow>
        
        <Divider/>
    </>
);

export default DetailTitleRow;